// src/router/statusProcesso.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const statusProcessoBreadcrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Status',
        to: 'Status'
    }
]

export default [
    {
        path: '/status',
        name: 'Status',
        component: () => import('@/views/StatusProcesso/StatusProcessoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Status',
            breadcrumb: statusProcessoBreadcrumb
        },
    },
    {
        path: '/status/novo',
        name: 'NovoStatus',
        component: () => import('@/views/StatusProcesso/StatusProcessoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Status',
            breadcrumb: [
                ...statusProcessoBreadcrumb,
                {
                    label: 'Novo Status',
                    to: 'NovoStatus'
                }
            ]
        }
    },
    {
        path: '/status/:id/edit',
        name: 'StatusEdit',
        component: () => import('@/views/StatusProcesso/StatusProcessoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Status',
            breadcrumb: [
                ...statusProcessoBreadcrumb,
                {
                    label: 'Editar Status',
                    to: 'NovoStatus'
                }
            ]
        }
    }

];
